export default __webpack_public_path__ + "static/media/2851f98dce6d04e4.261cb8925abcd28645439dd5d6134477.svg";